var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zip_15992253 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_273852704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_273853712",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 51.1999C32.6496 51.1999 32.3652 50.9156 32.3652 50.565V39.9646C32.3652 39.6141 32.6496 39.3301 33 39.3301C33.3506 39.3299 33.6349 39.6143 33.6349 39.9648V50.565C33.6349 50.9155 33.3506 51.1999 33 51.1999Z",
    fill: "#F1722E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273853616",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1429 51.1977H21.288C21.0555 51.1977 20.8416 51.0707 20.7304 50.8664C20.6193 50.6622 20.6287 50.4134 20.755 50.2182L26.9764 40.5997H21.288C20.9375 40.5997 20.6533 40.3156 20.6533 39.9652C20.6533 39.6145 20.9375 39.3302 21.288 39.3302L28.1429 39.3301C28.3755 39.3301 28.5894 39.4575 28.7006 39.6616C28.8117 39.8659 28.8023 40.1146 28.676 40.3097L22.4546 49.9278H28.1429C28.4935 49.9278 28.7777 50.2124 28.7777 50.563C28.7777 50.9133 28.4935 51.1977 28.1429 51.1977Z",
    fill: "#F1722E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273853472",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4901 44.6303H42.0619C43.1732 44.6303 44.0772 43.7263 44.0772 42.615C44.0772 41.5037 43.1732 40.5998 42.0619 40.5998L38.4901 40.5997V44.6303ZM42.0619 45.8999H37.8554C37.5049 45.8999 37.2205 45.6158 37.2205 45.2652V39.9648C37.2205 39.6143 37.5048 39.3301 37.8554 39.3301L42.0619 39.3301C43.8731 39.3301 45.3467 40.8037 45.3467 42.615C45.3467 44.4262 43.8731 45.9 42.0619 45.8999Z",
    fill: "#F1722E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273853448",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8555 51.2005C37.505 51.2005 37.2206 50.9164 37.2206 50.5658V45.2654C37.2206 44.9149 37.5049 44.6309 37.8555 44.6309C38.2061 44.6307 38.4903 44.915 38.4903 45.2656V50.5656C38.4903 50.9161 38.2061 51.2007 37.8555 51.2005Z",
    fill: "#F1722E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273853256",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2744 35.9197C53.9238 35.9197 53.6396 35.6356 53.6396 35.285V21.489C53.6396 19.102 52.6914 16.8128 51.0035 15.125L43.2099 7.3314C41.5221 5.6436 39.2329 4.6954 36.846 4.6954H13.0053C12.6497 4.6954 12.3603 4.98476 12.3603 5.34035V35.2847C12.3603 35.6355 12.0762 35.9198 11.7256 35.9198C11.375 35.9197 11.0908 35.6356 11.0908 35.285V5.3402C11.0908 4.28452 11.9496 3.42586 13.0053 3.42586L40.8368 3.42578C41.0051 3.42578 41.1666 3.49273 41.2856 3.61183L54.7232 17.0493C54.8422 17.1683 54.9091 17.3299 54.9091 17.4983L54.9092 35.2847C54.9092 35.6355 54.6249 35.9198 54.2744 35.9197ZM52.9947 61.5733H13.0055C11.9498 61.5733 11.091 60.7145 11.091 59.659V55.2448C11.091 54.8943 11.3752 54.6102 11.7258 54.6102C12.0763 54.6101 12.3605 54.8944 12.3605 55.2449V59.6589C12.3605 60.0144 12.6498 60.3038 13.0055 60.3038L52.9947 60.3037C53.3503 60.3037 53.6396 60.0146 53.6396 59.659V55.2448C53.6396 54.8943 53.9238 54.6102 54.2744 54.6102C54.625 54.6101 54.9091 54.8944 54.9091 55.2449L54.9092 59.6589C54.9092 60.7143 54.0503 61.5735 52.9947 61.5733Z",
    fill: "#10002E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273853520",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7239 35.9196C16.3734 35.9196 16.0892 35.6354 16.0892 35.2848V9.05881C16.0892 8.70797 16.3734 8.42409 16.7239 8.42409L40.837 8.42383C41.1874 8.42383 41.4716 8.70824 41.4716 9.05884C41.4716 9.4093 41.1874 9.6936 40.8369 9.6936L22.3588 9.69348C19.5974 9.69346 17.3588 11.932 17.3588 14.6935V35.2846C17.3588 35.6354 17.0745 35.9196 16.7239 35.9196ZM49.2762 35.9196C48.9256 35.9196 48.6414 35.6354 48.6414 35.2848V17.4981C48.6414 17.1473 48.9256 16.8634 49.2762 16.8634C49.6266 16.8631 49.9109 17.1476 49.9109 17.4982L49.911 35.2846C49.911 35.6354 49.6266 35.9196 49.2762 35.9196Z",
    fill: "#10002E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273853976",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2744 18.1329H41.9118C40.969 18.1329 40.202 17.366 40.202 16.4232L40.202 4.06039C40.202 3.70985 40.4862 3.42578 40.8368 3.42578C41.1873 3.42571 41.4715 3.71 41.4715 4.06057V16.4232C41.4715 16.6657 41.6691 16.8634 41.9118 16.8634L54.2744 16.8632C54.625 16.8632 54.9091 17.1477 54.9091 17.4982C54.9092 17.8484 54.6249 18.1329 54.2744 18.1329Z",
    fill: "#10002E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_273853736",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6427 35.92C10.4614 35.92 10.3081 36.0732 10.3081 36.2545V54.276C10.3081 54.4572 10.4614 54.6106 10.6427 54.6106L55.3574 54.6105C55.5387 54.6105 55.6919 54.4574 55.6919 54.2761V36.2545C55.6919 36.073 55.5386 35.9201 55.3573 35.9201L10.6427 35.92ZM55.3574 55.8801H10.6427C9.75816 55.8801 9.03857 55.1605 9.03857 54.2761V36.2545C9.03857 35.3699 9.75816 34.6505 10.6427 34.6505L55.3574 34.6504C56.2418 34.6504 56.9615 35.3701 56.9615 36.2545L56.9615 54.276C56.9615 55.1603 56.2418 55.8801 55.3574 55.8801Z",
    fill: "#F1722E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273853592",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.588 30.7033H20.4122C20.0616 30.7033 19.7775 30.4191 19.7775 30.0685C19.7775 29.7178 20.0616 29.4337 20.4122 29.4337L45.588 29.4336C45.9387 29.4336 46.2228 29.7179 46.2228 30.0685C46.2228 30.4191 45.9386 30.7033 45.588 30.7033Z",
    fill: "#F1722E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273853928",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.588 25.4395H20.4122C20.0616 25.4395 19.7775 25.1556 19.7775 24.8051C19.7775 24.4544 20.0616 24.1701 20.4122 24.1701L45.588 24.1699C45.9387 24.1699 46.2228 24.4545 46.2228 24.8051C46.2228 25.1554 45.9386 25.4398 45.588 25.4395Z",
    fill: "#F1722E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273853208",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1487 20.1756H20.4121C20.0615 20.1756 19.7773 19.8915 19.7773 19.541C19.7773 19.1904 20.0615 18.9062 20.4121 18.9062H37.1487C37.4993 18.9062 37.7835 19.1905 37.7835 19.541C37.7835 19.8915 37.4993 20.1757 37.1487 20.1756Z",
    fill: "#F1722E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_273852728",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1487 14.9119H20.4121C20.0615 14.9119 19.7773 14.6279 19.7773 14.2774C19.7773 13.9267 20.0615 13.6427 20.4121 13.6427L37.1487 13.6426C37.4993 13.6426 37.7835 13.9268 37.7835 14.2774C37.7835 14.6278 37.4993 14.9121 37.1487 14.9119Z",
    fill: "#F1722E"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadZip);
export default __webpack_public_path__ + "static/media/uploadZip.b72a15d8.svg";
export { ForwardRef as ReactComponent };